// @ts-nocheck
import { TsadvUser } from "../../../../cuba/entities/base/tsadv$UserExt";
import { DicHrRole } from "../../../../cuba/entities/base/tsadv$DicHrRole";
import Candidate from "../../../pages/Bproc/component/Candidate";
import { Msg } from "@cuba-platform/react";
import { ExtTaskData } from "../../../../cuba/entities/base/tsadv_ExtTaskData";
import React from "react";

interface BaseBlockProps {
  comment: string;
  colorClass: string;
  intl: any
  outcome: string,
  candidates: TsadvUser[],
  hrRole: DicHrRole
}
interface CommentProps extends Pick<BaseBlockProps, 'comment'> {}
interface OutcomeBlockProps extends Pick<BaseBlockProps, 'colorClass' | 'intl' | 'outcome'> {}
interface HrRoleBlockProps extends Pick<BaseBlockProps, 'candidates' | 'hrRole' | 'colorClass'> {}

export const HrRoleBlock = ({ candidates, hrRole, colorClass }: HrRoleBlockProps) => {
  return (
    <div className="flex items-start">
      <div className={`w-1 absolute h-full left-0 top-0 rounded-sm mr-2 bg-${colorClass}`} />
      <div className="break-words flex flex-row w-full flex-wrap items-center gap-2 justify-between text-xs">
        <Candidate isShortName candidates={candidates || []} />
        <span className="text-gray-800">{hrRole?.langValue || ""}</span>
      </div>
    </div>
  );
};

export const OutcomeBlock = ({ outcome, intl, colorClass }: OutcomeBlockProps) => {
  if (!outcome) return null;

  return (
    <div className={`break-words text-${colorClass}`}>
      {intl.formatMessage({ id: "result." + outcome })}
    </div>
  );
};

export const CommentBlock = ({ comment }: CommentProps) => {
  if (!comment) return null;

  return (
    <div className="flex gap-2 text-gray-800 items-center text-xs">
      <Msg entityName={ExtTaskData.NAME} propertyName="comment" />:
      <div className="break-words text-gray-600">{comment}</div>
    </div>
  );
};
